import React, {useEffect } from "react";
import { Col, Container, Row } from 'reactstrap';
import { reduxForm } from 'redux-form';

import FormFilter from '../Indicators/components/FormFilter';

const Indicators = ({ history, location }) => {
    
    useEffect(() => {
        
    }, []);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Indicadores</h3>
                </Col>
            </Row>
            <FormFilter/>
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_indicators', // a unique identifier for this form
})(Indicators);